var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._b({},'label',_vm.$attrs,false),[_c('strong',[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('sup',[_vm._v("*")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }